module.exports = __webpack_public_path__ + "img/193.402ad218.jpg";